(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fa-credentials"] && !Shopify.designMode) return;
  try {
    
  /* 证书轮播：轨道里是三份相同内容，停在中间那份；滚到两侧副本时瞬移回中间对应位置，形成无缝循环。
     同一页可能有两组轮播，按容器逐个绑定；主题编辑器重载 section 时会换掉节点，所以按节点打标记而不是只跑一次。 */
  if (!window.__faCarouselBound) {
    window.__faCarouselBound = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const bind = (box) => {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      const track = box.querySelector('.fa-cc-track');
      const slides = [...track.children];
      const count = Number(box.dataset.count);
      if (!count || slides.length !== count * 3) return;
      const nameEl = box.querySelector('[data-cc-name]');
      const indexEl = box.querySelector('[data-cc-index]');
      const bar = box.querySelector('[data-cc-bar]');
      let current = -1;
      const setCurrent = (i) => {
        if (i === current) return;
        current = i;
        const real = i % count;
        slides.forEach((li, n) => li.classList.toggle('fa-is-current', n === i));
        if (nameEl) nameEl.textContent = slides[real].dataset.ccLabel || '';
        indexEl.textContent = String(real + 1).padStart(2, '0');
        bar.style.width = `${((real + 1) / count) * 100}%`;
      };
      const centerOf = (li) => li.offsetLeft + li.offsetWidth / 2;
      const goTo = (i) => {
        const li = slides[Math.max(0, Math.min(slides.length - 1, i))];
        track.scrollTo({ left: centerOf(li) - track.clientWidth / 2, behavior: reduced.matches ? 'auto' : 'smooth' });
      };
      const go = (dir) => goTo(current + dir);
      const nearest = () => {
        const mid = track.scrollLeft + track.clientWidth / 2;
        return slides.reduce((best, li, n) => (Math.abs(centerOf(li) - mid) < Math.abs(centerOf(slides[best]) - mid) ? n : best), 0);
      };
      // 瞬移期间关掉过渡，否则缩放与透明度会在跳位时闪一下
      const jumpTo = (target, from) => {
        box.classList.add('fa-is-jumping');
        track.scrollLeft += centerOf(slides[target]) - centerOf(slides[from]);
        setCurrent(target);
        void track.offsetWidth;
        window.requestAnimationFrame(() => box.classList.remove('fa-is-jumping'));
      };
      const recentre = () => {
        const n = nearest();
        if (n < count) jumpTo(n + count, n);
        else if (n >= count * 2) jumpTo(n - count, n);
      };
      let scrollQueued = false;
      let settleTimer = 0;
      track.addEventListener('scroll', () => {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(recentre, 160);
        if (scrollQueued) return;
        scrollQueued = true;
        window.requestAnimationFrame(() => { scrollQueued = false; setCurrent(nearest()); });
      }, { passive: true });
      box.classList.add('fa-is-jumping');
      track.scrollLeft = centerOf(slides[count]) - track.clientWidth / 2;
      setCurrent(count);
      window.requestAnimationFrame(() => box.classList.remove('fa-is-jumping'));

      let timer = 0;
      const play = () => { if (reduced.matches || timer) return; timer = window.setInterval(() => go(1), 4000); };
      const stop = () => { if (timer) { window.clearInterval(timer); timer = 0; } };
      // 点到非当前卡时先把它滚到中间，再点一次才打开大图
      slides.forEach((li, n) => li.querySelector('a').addEventListener('click', (event) => {
        if (n === current) return;
        event.preventDefault();
        goTo(n);
        stop();
      }));
      box.querySelector('[data-cc="prev"]').addEventListener('click', () => { go(-1); stop(); });
      box.querySelector('[data-cc="next"]').addEventListener('click', () => { go(1); stop(); });
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', play);
      box.addEventListener('focusin', stop);
      box.addEventListener('touchstart', stop, { passive: true });
      new IntersectionObserver(([entry]) => { if (entry.isIntersecting) play(); else stop(); }).observe(box);
    };
    const start = () => document.querySelectorAll('[data-fa-carousel]').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-faq"] && !Shopify.designMode) return;
  try {
    
  // 多个 section 都可能出现 FAQ 折叠；监听挂在 document 上，重复绑定会让一次点击被切换两次
  if (!window.__faFaqBound) {
    window.__faFaqBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.fa-faq-item > button');
      if (!button) return;
      const open = button.parentElement.classList.toggle('fa-is-open');
      button.setAttribute('aria-expanded', String(open));
      button.lastElementChild.textContent = open ? '−' : '+';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-form"] && !Shopify.designMode) return;
  try {
    
  // 选项卡监听挂在 document 上，同页多个表单区或编辑器重载 section 时只绑定一次，避免一次点击被处理两遍
  if (!window.__faFormTabsBound) {
    window.__faFormTabsBound = true;
    const select = (root, type) => {
      root.querySelectorAll('[data-form-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.formTab === type)));
      root.querySelectorAll('[data-form-panel]').forEach((p) => { p.hidden = p.dataset.formPanel !== type; });
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-form-tab]');
      if (!button) return;
      select(button.closest('[data-fa-section="form"]'), button.dataset.formTab);
    });
    const init = () => {
      // 原型用 contact/chinese 这类路由直接打开对应表单，站上用 ?form= 承接；institution 是原型里 global 的别名
      const wanted = new URLSearchParams(window.location.search).get('form');
      const aliased = wanted === 'institution' ? 'global' : wanted;
      document.querySelectorAll('[data-fa-section="form"]').forEach((root) => {
        if (!root.querySelector('[data-form-tab]')) return;
        // 提交后页面带着结果重新加载：结果落在哪张表里就停在哪张，否则访客看不到成功或出错提示
        const result = root.querySelector('.fa-form-success, .fa-form-error');
        const type = result ? result.closest('[data-form-panel]').dataset.formPanel : aliased;
        if (type && root.querySelector(`[data-form-panel="${type}"]`)) select(root, type);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-header"] && !Shopify.designMode) return;
  try {
    
  // 监听一律挂在 document 上：编辑器重载 section 后节点会被替换，委托不必重绑；守卫避免重复绑定
  if (!window.__faHeaderBound) {
    window.__faHeaderBound = true;
    // 与原型同一断点：宽屏且能悬停时悬停展开，其余情况点击展开
    const hoverNav = window.matchMedia('(hover: hover) and (min-width: 1280px)');
    let closeTimer = 0;
    const headers = () => [...document.querySelectorAll('[data-fa-header]')];
    const topButton = (menu) => menu.querySelector(':scope > button');
    const setMenu = (header, menu, open) => {
      header.querySelectorAll('.fa-nav-menu').forEach((other) => {
        const on = other === menu && open;
        other.classList.toggle('fa-is-open', on);
        topButton(other).setAttribute('aria-expanded', String(on));
      });
    };
    const closeAll = (header) => {
      header.querySelector('.fa-primary-nav').classList.remove('fa-is-open');
      header.querySelector('.fa-menu-button').setAttribute('aria-expanded', 'false');
      setMenu(header, null, false);
    };

    document.addEventListener('click', (event) => {
      const menuButton = event.target.closest('[data-fa-header] .fa-menu-button');
      if (menuButton) {
        const header = menuButton.closest('[data-fa-header]');
        const open = header.querySelector('.fa-primary-nav').classList.toggle('fa-is-open');
        menuButton.setAttribute('aria-expanded', String(open));
        return;
      }
      const top = event.target.closest('[data-fa-header] .fa-nav-menu > button');
      if (top) {
        const menu = top.parentElement;
        // 原型在悬停模式下点一级栏目直接进总览页；键盘触发（detail 为 0）改为展开面板，
        // 否则键盘用户在桌面宽度下永远打不开下拉
        if (hoverNav.matches && event.detail !== 0) {
          const first = menu.querySelector('.fa-nav-menu-panel a[href]');
          if (first) {
            window.location.href = first.href;
            return;
          }
        }
        setMenu(top.closest('[data-fa-header]'), menu, !menu.classList.contains('fa-is-open'));
        return;
      }
      for (const header of headers()) {
        // 同页锚点链接不会重新加载页面，要手动收起
        if (header.contains(event.target) && event.target.closest('.fa-primary-nav a[href]')) {
          closeAll(header);
          continue;
        }
        if ([...header.querySelectorAll('.fa-nav-menu')].some((menu) => menu.contains(event.target))) continue;
        setMenu(header, null, false);
      }
    });

    document.addEventListener('mouseover', (event) => {
      if (!hoverNav.matches) return;
      const menu = event.target.closest('[data-fa-header] .fa-nav-menu');
      if (!menu) return;
      clearTimeout(closeTimer);
      if (!menu.classList.contains('fa-is-open')) setMenu(menu.closest('[data-fa-header]'), menu, true);
    });
    document.addEventListener('mouseout', (event) => {
      if (!hoverNav.matches) return;
      const menu = event.target.closest('[data-fa-header] .fa-nav-menu');
      if (!menu || menu.contains(event.relatedTarget)) return;
      clearTimeout(closeTimer);
      // 留 200ms 余量，鼠标斜穿到面板的途中不会把面板关掉
      closeTimer = setTimeout(() => {
        if (menu.classList.contains('fa-is-open') && !menu.contains(document.activeElement)) setMenu(menu.closest('[data-fa-header]'), menu, false);
      }, 200);
    });
    // 桌面宽度下键盘焦点移出已展开的面板即收起，避免面板盖住后续内容
    document.addEventListener('focusout', (event) => {
      if (!hoverNav.matches || !(event.target instanceof Element)) return;
      const menu = event.target.closest('[data-fa-header] .fa-nav-menu.fa-is-open');
      if (!menu || (event.relatedTarget && menu.contains(event.relatedTarget))) return;
      setMenu(menu.closest('[data-fa-header]'), menu, false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const header of headers()) {
        const openMenu = header.querySelector('.fa-nav-menu.fa-is-open');
        const drawerOpen = header.querySelector('.fa-primary-nav.fa-is-open');
        const hadFocus = header.contains(document.activeElement);
        closeAll(header);
        if (!hadFocus) continue;
        // 焦点送回触发它的按钮，否则关掉后焦点落在已隐藏的元素上
        const menuButton = header.querySelector('.fa-menu-button');
        if (drawerOpen && menuButton.offsetParent) menuButton.focus();
        else if (openMenu) topButton(openMenu).focus();
      }
    });

    /* 往下滚过公告条后页头摊成贴顶长条。滚动容器在宽屏是 .page-wrapper、窄屏是窗口，
       所以在捕获阶段监听全部滚动，统一取两者中较大的滚动距离 */
    let queued = false;
    const apply = () => {
      queued = false;
      const wrapper = document.querySelector('.page-wrapper');
      const y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      for (const header of headers()) {
        const announce = header.parentElement.querySelector('.fa-announce');
        const threshold = Math.max(announce ? announce.offsetHeight : 0, 1);
        if (y >= threshold - 0.5) header.classList.add('fa-is-stuck');
        else header.classList.remove('fa-is-stuck');
      }
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    };
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue);
    document.addEventListener('shopify:section:load', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(document.documentElement);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
    else queue();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-process"] && !Shopify.designMode) return;
  try {
    
  // 多个 section 都可能出现 FAQ 折叠；监听挂在 document 上，重复绑定会让一次点击被切换两次
  if (!window.__faFaqBound) {
    window.__faFaqBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.fa-faq-item > button');
      if (!button) return;
      const open = button.parentElement.classList.toggle('fa-is-open');
      button.setAttribute('aria-expanded', String(open));
      button.lastElementChild.textContent = open ? '−' : '+';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
